import { IconSvgProps } from "@/types";
import Image from 'next/image';
import * as React from "react";
import increff_logo from '../public/images/logo.png';

export const IncreffLogo = ({width = 25}: {width?: number}) => (
	<Image
		src={increff_logo}
		width={width}
		alt='Increff Logo'
		className='overflow-hidden transition-all duration-300 delay-150 me-2'
	/>
);

export const SearchIcon = (props: IconSvgProps) => (
	<svg
		aria-hidden="true"
		fill="none"
		focusable="false"
		height="1em"
		role="presentation"
		viewBox="0 0 24 24"
		width="1em"
		{...props}
	>
		<path
			d="M11.5 21C16.7467 21 21 16.7467 21 11.5C21 6.25329 16.7467 2 11.5 2C6.25329 2 2 6.25329 2 11.5C2 16.7467 6.25329 21 11.5 21Z"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
		/>
		<path
			d="M22 22L20 20"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth="2"
		/>
	</svg>
);

